import React from 'react';

import IconPencil from '@pkg/assets/icons/pencil.svg?react';

import { StyledEditIcon } from './EditIcon.style';

export interface EditIconProps {
    subdued?: boolean;
}

export function EditIcon({ subdued = false }: EditIconProps) {
    return (
        <StyledEditIcon $subdued={subdued}>
            <IconPencil />
        </StyledEditIcon>
    );
}
